// css =>
import "../../BaseStructure.css";
import Styled from "./fotter.module.css";

// context =>
import { useTheme } from '../../context/theme-context';

const Fotter = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div
            className={`row ${ Styled.FotterBox } `}
            style={{
                backgroundColor: theme === "day" ? "#778066" : ""
            }}
        >
            <div className="col-12">
                <p
                    style={{
                        color: theme === "day" ? "#FFFFFF" : ""
                    }}>Designed & Developed by HERAM Studio</p>
            </div>
        </div>
    );
}

export default Fotter;
